import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
import IconButton from "../../IconButton";
import classNames from "classnames";
import './index.scss';

export const TimeInfo = ({
  label,
  isWarning,
  value,
  isCooking,
  cookingTime,
  isAlwaysShowCookingTimeSpan,
  warningDescription = '',
  icon: Icon
}) => {
  const { t } = useTranslation();

  const handleShowAlert = useCallback(() => {
    window.alert(`${t('common.warning')}\n\n${warningDescription}`);
  }, [t, warningDescription]);

  return (
    <div className={'time-info-container'}>
      {!!Icon && <Icon />}

      {label && <span className={'time-info-label'}>{label}</span>}

      {isAlwaysShowCookingTimeSpan &&
        !!cookingTime &&
        isCooking && (
          <span className={'time-info-time'}>
            {t('draft.xMinutes', { min: cookingTime || '0' })},
          </span>
        )}

      <button
        disabled={!isWarning}
        onClick={handleShowAlert}
        className={classNames('time-info-time-container', {'time-info-time-container-warning': isWarning})}
      >
        <span
          className={classNames('time-info-time', {'time-info-time-warning': isWarning})}
        >
          {value}
        </span>

        {isWarning && (
          <IconButton isIcon iconName={'warningTime'}/>
        )}
      </button>
    </div>
  );
};